import {KTSVG} from '../../../_metronic/helpers'
import {FC, useEffect, useState, forwardRef, useImperativeHandle, useRef} from 'react'
import {Modal} from 'react-bootstrap'
import Select from 'react-select'
import {useAllexpensetypes, useAddexpenses} from '../../contextProviders/Atomqueryprovider'
import {useAuth} from '../../../app/modules/auth'

import {useSelectStyles} from '../../helpers/useSelectStyles'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)

type Props = {
  show: boolean
  handleClose: () => void
  sumexpenserefetch?: () => void
  sumprofitorlossrefetch?: () => void
  ref: any
}
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
export const Addexpensesmore: FC<Props> = forwardRef((props, ref) => {
  const [submit_Expense, setSubmit_Expense] = useState(false)

  const [newSetquantity, setNewSetquantity] = useState(false)
  const [newSetprice, setNewSetprice] = useState<number>(0)
  const [expense_type_id, setExpense_type_id] = useState<number>(0)
  const {currentUser, logout} = useAuth()
  const [selectedDateTime, setSelectedDateTime] = useState<Date>(new Date())

  const [localTimeZone, setLocalTimeZone] = useState<string>('')

  useEffect(() => {
    setLocalTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
  }, [])

  const formatDateForInput = (date: Date) => {
    const pad = (n: number) => (n < 10 ? '0' + n : n)
    const year = date.getFullYear()
    const month = pad(date.getMonth() + 1)
    const day = pad(date.getDate())
    const hour = pad(date.getHours())
    const minute = pad(date.getMinutes())
    return `${year}-${month}-${day}T${hour}:${minute}`
  }

  const {
    isLoading: expensetypeloading,
    isSuccess: expensetypesuccess,
    data: expensetypedata,
  } = useAllexpensetypes()

  const handleDateTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputDate = new Date(e.target.value)
    if (!isNaN(inputDate.getTime())) {
      setSelectedDateTime(inputDate)
    } else {
      setSelectedDateTime(new Date())
    }
  }

  const handlepricechange = (e: any) => {
    setNewSetprice(e.target.value)
  }

  useImperativeHandle(ref, () => ({
    Resetmodalexpensesvalues() {
      setSubmit_Expense(false)
      setNewSetprice(0)
      setSelectedDateTime(new Date())
      setNewSetquantity(false)
      setExpense_type_id(0)
    },
  }))

  const handleexpenseChange = (e: any) => {
    if (e != null) {
      setExpense_type_id(e.value)
      setNewSetquantity(true)
    } else {
      setNewSetquantity(false)
    }
  }

  const expenseadded: any = []

  expenseadded.push({
    expense_amount: newSetprice,
    date_expense_made: formatDateForInput(selectedDateTime),
    user_id: currentUser?.user_id,
    expense_type_id: expense_type_id,
  })

  const {mutateAsync: addexpensesmutateAsync} = useAddexpenses(expenseadded)

  const submitExpense = async () => {
    setSubmit_Expense(true)

    addexpensesmutateAsync(expenseadded, {
      onSuccess: () => {
        setSubmit_Expense(false)
        props.handleClose()
      },
      onError(error, variables, context) {
        console.log(error)
        setSubmit_Expense(false)
        // Do NOT close the modal on error — user should be able to retry
      },
    })
  }

  let options =
    expensetypesuccess &&
    expensetypedata?.data.map((val: any, index: any) => {
      return {
        value: val.expense_type_id,
        label: val.expense_name,
      }
    })

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>Add Expense</h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form className='form' noValidate>
            {/* begin::Input group */}
            <div className='fv-row mb-7'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Add Expense</label>
              {/* end::Label */}

              <Select
                options={options}
                styles={useSelectStyles()}
                isDisabled={false}
                isLoading={expensetypeloading}
                isSearchable={true}
                onChange={(e: any) => handleexpenseChange(e)}
                placeholder="Add expense type ..."
              />
            </div>
            {/* end::Input group */}

            {/* begin::Input group */}
            <div className='row'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>
                Total Expenditure ({CURRENCY_APP})
              </label>
              {/* end::Label */}

              <div className='col-lg-6 fv-row mb-7'>
                <input
                  placeholder='0.00'
                  className='form-control form-control-lg form-control-solid'
                  type='number'
                  autoComplete='off'
                  value={parseInt(newSetprice.toString())}
                  disabled={!newSetquantity}
                  onChange={(e) => handlepricechange(e)}
                />
              </div>
            </div>
            {/* end::Input group */}

            {/* begin::Input group */}
            <div className='row'>
              

              <div className='col-lg-6 fv-row mb-7'>
                {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Date & Time</label>
              {/* end::Label */}
                <input
                  type='datetime-local'
                  className='form-control form-control-lg form-control-solid'
                  value={formatDateForInput(selectedDateTime)}
                  onChange={handleDateTimeChange}
                />
              </div>
            </div>
            {/* end::Input group */}
          </form>
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-danger'
            onClick={submitExpense}
            disabled={
              !newSetquantity ||
              submit_Expense ||
              typeof newSetprice === 'number' ||
              isNaN(selectedDateTime.getTime())
            }
          >
            {!submit_Expense && <span className='indicator-label'>Add Expense</span>}
            {submit_Expense && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
})
